<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="titleEnum[type]"
        class="dialog-container"
        width="500px"
        :close-on-click-modal="!forbidClose"
        :close-on-press-escape="!forbidClose"
        :show-close="!forbidClose"
    >
        <div>
            <!-- 提示信息 -->
            <div v-if="message" class="message">
                {{ message }}
            </div>
            <el-form
                :model="form"
                :rules="rules"
                ref="formRef"
                label-width="120px"
            >
                <el-form-item v-if="type === 'gender'" label="性别">
                    <el-select v-model="form.gender" placeholder="请选择性别">
                        <el-option
                            :label="genderEnum[0]"
                            :value="0"
                        ></el-option>
                        <el-option
                            :label="genderEnum[1]"
                            :value="1"
                        ></el-option>
                        <el-option
                            :label="genderEnum['-1']"
                            :value="-1"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <template v-else>
                    <el-form-item label="手机号">
                        <div>{{ form.phone }}</div>
                    </el-form-item>
                    <el-form-item label="验证码" prop="oldAuthCode">
                        <el-input
                            v-model="form.oldAuthCode"
                            placeholder="请输入原手机号验证码"
                        ></el-input>
                        <div class="btn" @click="handleGetValidateCode('old')">
                            {{
                                countdownOld > 0
                                    ? `${countdownOld}S`
                                    : '获取验证码'
                            }}
                        </div>
                    </el-form-item>
                </template>
                <!-- 更改手机号时显示 -->
                <template v-if="type === 'phone'">
                    <el-form-item label="新手机号" prop="newPhone">
                        <el-input
                            v-model="form.newPhone"
                            placeholder="请输入新手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="newAuthCode">
                        <el-input
                            v-model="form.newAuthCode"
                            placeholder="请输入新手机号验证码"
                            maxlength="11"
                        ></el-input>
                        <div class="btn" @click="handleGetValidateCode('new')">
                            {{
                                countdownNew > 0
                                    ? `${countdownNew}S`
                                    : '获取验证码'
                            }}
                        </div>
                    </el-form-item>
                </template>
                <!-- 更改密码时显示 -->
                <template v-if="type === 'password'">
                    <el-form-item label="新密码" prop="password">
                        <el-input
                            v-model="form.password"
                            placeholder="请输入密码"
                            minlength="6"
                            maxlength="16"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="再次确认密码" prop="checkPassword">
                        <el-input
                            v-model="form.checkPassword"
                            placeholder="请输入密码"
                            minlength="6"
                            maxlength="16"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="!forbidClose" @click="handleCancel">取 消</el-button>
            <el-button
                :disabled="loading"
                :loading="loading"
                type="primary"
                @click="handleSubmit"
                >确 定</el-button
            >
        </span>
        <!-- 图形验证码 -->
        <graph-code
            :visible.sync="dialogValidateCodeOptions.visible"
            @onOk="onOkValidate"
            ref="graphCode"
            :phone="dialogValidateCodeOptions.phone"
            type="profile"
        />
    </el-dialog>
</template>
<script>
import {
    ApiUpdateUserInfo,
    ApiUpdateUserPassword,
    ApiUpdateUserPhone
} from '@/api/user';
import { genderEnum } from '../constants';
import GraphCode from '@/components/Graph-Code';
import { rules } from '../constants';
import { removeCookie } from '@/utils/cookie';
export default {
    name: 'EditDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
        // 是否在修改成功后保持登录状态（不退出系统）
        keepLogin: {
            type: Boolean,
            default: false
        },
        // 是否禁止关闭和取消
        forbidClose: {
            type: Boolean,
            default: false
        },
        // 外部传入的用户信息，优先使用
        userInfo: {
            type: Object,
            default: null
        },
        // 提示信息
        message: {
            type: String,
            default: ''
        }
    },
    components: {
        GraphCode
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'));
            } else {
                if (this.form.checkPasswrod !== '') {
                    this.$refs.formRef.validateField('checkPass');
                }
                callback();
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        const pass = [
            {
                required: true,
                message: '请输入密码',
                trigger: 'blur'
            },
            {
                min: 6,
                max: 16,
                message: '密码长度应在6-16之间',
                trigger: 'blur'
            }
        ];
        return {
            rules: {
                ...rules,
                password: [
                    ...pass,
                    {
                        validator: validatePass,
                        trigger: 'blur'
                    }
                ],
                checkPassword: [
                    ...pass,
                    {
                        validator: validatePass2,
                        trigger: 'blur'
                    }
                ]
            },
            genderEnum,
            titleEnum: {
                gender: '修改性别',
                phone: '修改手机号',
                password: '修改密码'
            },
            loading: false,
            form: {
                phone: '',
                oldAuthCode: '',
                newPhone: '',
                newAuthCode: '',
                gender: '',
                password: '',
                checkPassword: ''
            },
            validateType: '', // 记录当前触发的是哪一个获取验证按钮
            timerOld: null,
            timerNew: null,
            countdownOld: 0,
            countdownNew: 0,
            dialogValidateCodeOptions: {
                visible: false,
                phone: ''
            }
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        }
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                Object.assign(this.$data.form, this.$options.data().form);
                this.timerNew = null;
                this.timerOld = null;
                this.countdownOld = 0;
                this.countdownNew = 0;
                this.validateType = '';
            } else {
                this.initData();
            }
        }
    },
    created() {
        this.initData();
    },
    methods: {
        // 初始化数据
        initData() {
            const { gender, phone } = this.$store.getters.userInfo;
            this.form = {
                ...this.form,
                phone,
                gender
            };
        },
        onOkValidate() {
            if (this.validateType === 'Old') {
                this.countdownOld = 60;
                this.timerOld = setInterval(() => {
                    if (this.countdownOld <= 0) {
                        clearInterval(this.timerOld);
                    }
                    this.countdownOld--;
                }, 1000);
            }
            if (this.validateType === 'New') {
                this.countdownNew = 60;
                this.timerNew = setInterval(() => {
                    if (this.countdownNew <= 0) {
                        clearInterval(this.timerNew);
                    }
                    this.countdownNew--;
                }, 1000);
            }
        },
        // 获取验证码
        handleGetValidateCode(type) {
            if (type === 'new' && !this.form.newPhone) {
                this.$refs.formRef.validateField('newPhone');
                return;
            }
            this.dialogValidateCodeOptions = {
                visible: true,
                phone: type === 'new' ? this.form.newPhone : ''
            };
            type = type.charAt(0).toUpperCase() + type.slice(1);
            if (this[`countdown${type}`] > 0) return;
            // 记录当前点击的是哪一个验证码
            this.validateType = type;
        },
        handleCancel() {
            this.$refs.formRef.clearValidate();
            this.$emit('update:visible', false);
        },
        // 更新信息成功回调
        updateSuccessCb(message = '更新成功') {
            this.$message.success(message);
            this.$store.dispatch('set_userInfo').then(() => {
                // 如果是密码重置且设置了keepLogin，则不退出系统
                if (this.keepLogin) {
                    this.$emit('on-success');
                    this.$emit('update:visible', false);
                } else if (this.type !== 'gender') {
                    removeCookie('token', {
                        domain: location.hostname.replace(/.*?\./, '')
                    });
                    this.$router.push({
                        path: '/login'
                    });
                } else {
                    this.$emit('update:visible', false);
                }
                this.loading = false;
            });
        },
        // 更新基本信息
        updateBaseInfo() {
            const obj = {
                gender: this.form.gender
            };
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    ApiUpdateUserInfo(obj)
                        .then(res => {
                            this.updateSuccessCb(res.message);
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        // 更新手机号
        updatePhone() {
            const { oldAuthCode, newPhone, newAuthCode } = this.form;
            const obj = {
                oldAuthCode,
                newPhone,
                newAuthCode
            };
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    ApiUpdateUserPhone(obj)
                        .then(res => {
                            this.updateSuccessCb(res.message);
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        // 更新密码
        updatePassword() {
            const { oldAuthCode, password } = this.form;
            const obj = {
                authCode: oldAuthCode,
                newPwd: password
            };
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    ApiUpdateUserPassword(obj)
                        .then(res => {
                            this.updateSuccessCb(res.message);
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        handleSubmit() {
            if (this.loading) return;
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.type === 'gender') {
                        this.updateBaseInfo();
                    } else if (this.type === 'phone') {
                        this.updatePhone();
                    } else if (this.type === 'password') {
                        this.updatePassword();
                    }
                }
            });
        }
    },
    destroyed() {
        this.timerOld && clearInterval(this.timerOld);
        this.timerNew && clearInterval(this.timerNew);
    }
};
</script>
<style lang="scss" scoped>
.dialog-container {
    ::v-deep {
        .el-select {
            display: block;
        }
        .el-input {
            width: 236px;
        }
        .btn {
            cursor: pointer;
            vertical-align: middle;
            display: inline-block;
            margin-left: 16px;
            font-size: 14px;
            font-weight: 400;
            color: #0772eb;
            line-height: 14px;
        }
    }
    .message {
        color: #ff9800;
        font-size: 14px;
        margin-bottom: 20px;
        padding: 10px;
        background-color: #fff3e0;
        border-radius: 4px;
        border-left: 4px solid #ff9800;
    }
    .img-code {
        height: 40px;
        display: flex;
        align-items: center;
        img {
            height: 100%;
            margin-right: 10px;
        }
        .imgcode-input {
            width: 150px;
        }
        .text {
            color: #186fff;
        }
    }
}
</style>
